module.exports = __webpack_public_path__ + "static/10-c2b529b53fdeb67800dac66df2889c7a.jpg";